<template>
  <div
    id="print_received_invoices_modal"
    class="modal fade"
  >
    <div
      id="received-print-area"
      class="modal-dialog modal-full"
      style="max-width: 950px"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="print-float-left">
            <v-btn
              id="received-print-button"
              @click="printList"
              style="height:auto"
              outline
              color="primary"
            >{{ $t('printLogs.printButton') }}</v-btn>
          </div>
          <button
            id="received-close-button"
            type="button"
            class="close"
            @click="closeModal('print_received_invoices_modal')"
          >
            &times;
          </button>
        </div>

        <table
          style="width: 100%"
          id="head-table"
        >
          <tr>
            <td style="width: 130px;" class="print-pl-20">
              <img
                style="width: 110px; height: 100px"
                src="../../../assets/images/black_shipzone.png"
                alt=""
              />
            </td>
            <td>
              <table style="width: 100%;" class="print-ml-0">
                <tr>
                  <td style="font-size: 14px; font-weight: bold;" class="print-pr-20">{{ companyData.company_name }}</td>
                </tr>
                <tr>
                  <td style="font-size: 14px" class="print-pr-20">{{ companyData.company_address }}</td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <table style="width: 100%; margin-top: 10px;">
          <tr>
            <td style="text-align: center; padding: 8px 0;">
              <strong style="font-size: 20px; text-transform: uppercase;">{{ $t('invoice.receivedInvoicesTitle') }}</strong>
            </td>
          </tr>
        </table>

        <table
          style="width: 100%; border-collapse: collapse; border: 1px solid #000; margin-top: 10px;"
        >
          <thead>
            <tr style="background-color: #f2f2f2; font-size: 13px;">
              <th style="border: 1px solid #000; padding: 6px; text-align: center;">#</th>
              <th style="border: 1px solid #000; padding: 6px; text-align: right;">{{ $t('columns.total') }}</th>
              <th style="border: 1px solid #000; padding: 6px; text-align: right;">{{ $t('columns.amount') }}</th>
              <th style="border: 1px solid #000; padding: 6px; text-align: right;">{{ $t('logs.remainColumn') }}</th>
              <th style="border: 1px solid #000; padding: 6px; text-align: right;">{{ $t('columns.receivedAmount') }}</th>
              <th style="border: 1px solid #000; padding: 6px;">{{ $t('columns.receivedDate') }}</th>
              <th style="border: 1px solid #000; padding: 6px;">{{ $t('invoice.invoiceTooltip') }}</th>
              <th style="border: 1px solid #000; padding: 6px;">{{ $t('columns.customer') }}</th>
              <th style="border: 1px solid #000; padding: 6px;">{{ $t('customer.receivedBy') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(invoice, index) in printData"
              :key="invoice.order_invoice_id"
              style="font-size: 13px;"
            >
              <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ index + 1 }}</td>
              <td style="border: 1px solid #000; padding: 5px; text-align: right;">{{ invoice.total_price }}</td>
              <td style="border: 1px solid #000; padding: 5px; text-align: right;">{{ invoice.net_price }}</td>
              <td style="border: 1px solid #000; padding: 5px; text-align: right;">{{ invoice.remaining_amount }}</td>
              <td style="border: 1px solid #000; padding: 5px; text-align: right;">{{ invoice.received_amount != null ? invoice.received_amount : '—' }}</td>
              <td style="border: 1px solid #000; padding: 5px;">{{ invoice.received_at || '—' }}</td>
              <td style="border: 1px solid #000; padding: 5px;">{{ invoice.invoice_number }}</td>
              <td style="border: 1px solid #000; padding: 5px;">{{ invoice.customer_name }}</td>
              <td style="border: 1px solid #000; padding: 5px;">{{ invoice.received_by_name || '—' }}</td>
            </tr>
          </tbody>
        </table>

        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    printData: { default: () => [] },
    companyData: { default: () => ({}) },
    closeModal: { type: Function, required: true }
  },

  methods: {
    printList() {
      $('#received-close-button').hide()
      $('#received-print-button').hide()

      $('#received-print-area').printMe({ path: this.$_print_stylesheet_paths() })

      $('#received-close-button').show()
      $('#received-print-button').show()
    }
  }
}
</script>

<style scoped>
.modal {
  text-align: center;
  padding: 0 !important;
  overflow-x: auto;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/orderInvoice/PrintReceivedInvoices.vue